import { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  addNotification,
  clearNotifications,
  markAllNotificationsRead,
  NotificationState,
  removeNotification,
} from '../store';

/** Minimal slice of the store this hook depends on, so it stays app-agnostic. */
type WithNotifications = { notifications: NotificationState };

/**
 * Self-contained access to the notification history. Components can drop in
 * `useNotifications()` without any props being threaded through their parents.
 */
export const useNotifications = () => {
  const dispatch = useDispatch();
  const items = useSelector((state: WithNotifications) => state.notifications.items);

  const unreadCount = useMemo(
    () => items.filter((item) => !item.read).length,
    [items]
  );

  return {
    notifications: items,
    unreadCount,
    notify: (message: string, type?: 'success' | 'danger' | 'warning') =>
      dispatch(addNotification({ message, type })),
    markAllRead: () => dispatch(markAllNotificationsRead()),
    remove: (id: string) => dispatch(removeNotification(id)),
    clearAll: () => dispatch(clearNotifications()),
  };
};
